import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const cartApi = createApi({
    reducerPath:"cartApi" ,
    baseQuery : fetchBaseQuery({
        baseUrl: import.meta.env.VITE_API + "cart",
        prepareHeaders : (headers , {getState}) => {
            const token = getState().userSlice?.token ;
            if (token) {
                headers?.set("Authorization", `bearer ${token}`)
            }
            headers.set("Content-Type", "application/json")
            return headers ;
        }
    }),
    endpoints : (builder) => ({
        getCartItems : builder.query({
            query : () => ({
                url:"" ,
                method :"GET"
            })
        })
    })
})
export const  {useGetCartItemsQuery} = cartApi